<template>
  <div v-if="!!warningBanner.message && warningBanner.dismissed === false">
    <UiAlert
      :dismissible="true"
      type="error"
      @dismiss="warningBanner.dismiss()"
      class="rounded-none"
    >
      <div class="flex flex-wrap items-center justify-center gap-3">
        <div class="pc:basis-6/12">
          <div class="px-4 py-3 text-sm text-gray-50">
            <!-- The preflight reset strips link styles: keep the backend
                 message links visible (inherit the light text color) -->
            <span
              class="[&_a]:font-semibold [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:decoration-2"
              v-html="warningBanner.message"
            />
          </div>
        </div>
      </div>
    </UiAlert>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

import UiAlert from '@/shared/components/ui/UiAlert.vue'

import { useWarningBannerStore } from '../store/warningBanner.store'

const warningBanner = useWarningBannerStore()

onMounted(async () => {
  await warningBanner.loadWarningBanner()
})
</script>
